import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { useState } from 'react'

export const DeleteConfirmDialog = (props: {
  body?: JSX.Element | string
  onDelete: () => void
  children: (onDelete: () => void) => JSX.Element
}) => {
  const [deleting, setDeleting] = useState(false)
  return (
    <>
      {props.children(() => setDeleting(true))}
      <Dialog open={deleting} onClose={() => setDeleting(false)}>
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent>
          <Typography> </Typography>
          {props.body ?? 'Are you sure you want to delete? This action is permanent.'}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleting(false)}>Cancel</Button>
          <Button
            onClick={() => {
              if (deleting) {
                props.onDelete()
                setDeleting(false)
              }
            }}
            color="error"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
